import { PauseCircle, PlayCircle } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";

import { Spinner } from "../../Video/Video.elements";
import ButtonNext from "./ButtonNext/ButtonNext";
import ButtonPrevious from "./ButtonPrevious/ButtonPrevious";
import { Container } from "./ControlsCenter.elements";

type ControlsCenterProps = {
  isPlaying: boolean;
  handleClickPlayPause: () => void;
  handleClickVideoContainer: (event: React.MouseEvent) => void;
  handleClickPreviousVideo: () => void;
  handleClickNextVideo: () => void;
  loading: boolean;
};

function PlayPauseIcon({ isPlaying }: { isPlaying: boolean }): React.ReactElement {
  return isPlaying ? <PauseCircle aria-label={"pause"} /> : <PlayCircle aria-label={"play"} />;
}

export default function ControlsCenter({
  isPlaying,
  handleClickPlayPause,
  handleClickVideoContainer,
  handleClickNextVideo,
  handleClickPreviousVideo,
  loading,
}: ControlsCenterProps): React.ReactElement {
  const IconButtonStyles = {
    transform: "scale(2)",
  };

  return (
    <Container data-testid="controls-center" id="controls-center" onClick={handleClickVideoContainer}>
      <ButtonPrevious disabled={loading} handleClickPreviousVideo={handleClickPreviousVideo} />
      <IconButton
        aria-label={isPlaying ? "pause video" : "play video"}
        size="large"
        sx={IconButtonStyles}
        tabIndex={1}
        disabled={loading}
        onClick={handleClickPlayPause}
      >
        {loading ? <Spinner /> : <PlayPauseIcon isPlaying={isPlaying} />}
      </IconButton>
      <ButtonNext disabled={loading} handleClickNextVideo={handleClickNextVideo} />
    </Container>
  );
}
